// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","130":"d98b4e85","202":"c02fd540","266":"b41f1468","406":"668f46cc","762":"212d9b70","908":"536f0e0f"}[chunkId] + ".chunk.js";
};